import * as React from 'react';
import { TAdminPanel } from './AdminPanel.types';
import './AdminPanel.styles.scss';
import { NavigationPanel } from './components/NavigationPanel/NavigationPanel';
import { ADMIN_PANEL_CONFIG } from './config';

export const AdminPanel: TAdminPanel = () => {
  const [selectedPanelItemId, setSelectedPanelItemId] = React.useState<
    string | null
  >(ADMIN_PANEL_CONFIG[0].children[0].id);

  const SelectedConfigComponent = React.useMemo(() => {
    for (let i = 0; i < ADMIN_PANEL_CONFIG.length; i++) {
      const selectdChildConfig = ADMIN_PANEL_CONFIG[i].children.find(
        (amdinPanelChild) => amdinPanelChild.id === selectedPanelItemId
      );

      if (selectdChildConfig) {
        return selectdChildConfig.ConfigPage;
      }
    }
  }, [selectedPanelItemId]);

  return (
    <div className="admin-panel">
      <div className="admin-panel__container">
        <div className="admin-panel__container__nav">
          <NavigationPanel
            selectedPanelItemId={selectedPanelItemId}
            setSelectedPanelItem={setSelectedPanelItemId}
          />
        </div>
        <div className="admin-panel__container__configuration">
          <SelectedConfigComponent />
        </div>
      </div>
    </div>
  );
};
